import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-services/commerce-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Header name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Magento-Environment-Id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This value is displayed at `}<strong parentName="td">{`Stores`}</strong>{` > `}<strong parentName="td">{`Configuration`}</strong>{` > `}<strong parentName="td">{`Services`}</strong>{` > `}<strong parentName="td">{`Magento Services`}</strong>{` > `}<strong parentName="td">{`SaaS Environment`}</strong>{` or can be obtained by running the `}<inlineCode parentName="td">{`bin/magento config:show services_connector/services_id/environment_id`}</inlineCode>{` command.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Magento-Store-Code`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The code assigned to the store associated with the active store view. For example, `}<inlineCode parentName="td">{`main_website_store`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Magento-Store-View-Code`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The code assigned to the active store view. For example, `}<inlineCode parentName="td">{`default`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Magento-Website-Code`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The code assigned to the website associated with the active store view. For example, `}<inlineCode parentName="td">{`base`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`X-Api-Key`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This value must be set to `}<inlineCode parentName="td">{`search_gql`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      